<template>
  <table-component
    ref="summaryTable"
    :data="fetchData"
    sort-by="timestamp"
    :show-caption="false"
    class="datatable"
    :show-filter="false">
    <table-column
      show="timestamp"
      :label="$t('health.summary.day')"
      :formatter="timeFormatter"
      header-class="text-left"
      cell-class="table-component__text-left">
    </table-column>

    <table-column
      show="protein"
      :label="$t('health.summary.proteinUnit')"
      header-class="text-left"
      cell-class="table-component__text-left">
    </table-column>

    <table-column
      show="fat"
      :label="$t('health.summary.fatUnit')"
      header-class="text-left"
      cell-class="table-component__text-left">
    </table-column>

    <table-column
      show="carbs"
      :label="$t('health.summary.carbsUnit')"
      header-class="text-left"
      cell-class="table-component__text-left">
    </table-column>

    <table-column
      show="calories"
      :label="$t('health.summary.caloriesUnit')"
      header-class="text-left"
      cell-class="table-component__text-left">
    </table-column>
    <table-column :label="$t('health.summary.takeIntoAccount')"
                  :sortable="true"
                  :filterable="false"
                  header-class="table-component__minimum__width__column">
      <template slot-scope="row">
        <checkbox v-on:change="updateActive(row)"
                  :id=String(row.timestamp)
                  :checked="row.active"
                  check-size="m"/>
      </template>
    </table-column>

  </table-component>
</template>

<script>

import TableComponent from '@/components/shared/table/components/TableComponent';
import TableColumn from '@/components/shared/table/components/TableColumn';
import pagination from '@/components/shared/table/pagination';
import Checkbox from '@/components/shared/forms/Checkbox';

export default {
  name: 'SummaryTable',
  components: {
    TableComponent,
    TableColumn,
    Checkbox
  },

  data () {
    return {
      items: [],
      tablePageSize: 7,
      rowId: 0,
      tableState: {
        filter: '',
        page: 1,
        sort: {
          order: '',
          fieldName: ''
        }
      }
    };
  },
  mounted () {
    this.mapData();
  },
  watch: {
    data: {
      handler: function () {
        this.mapData();
      }
    },
    items: {
      handler: function () {
        this.updateCharts();
        this.$refs.summaryTable.refresh();
      }
    }
  },
  props: {
    data: {default: () => [], type: [Array, Function]}
  },
  methods: {
    mapData () {
      if (this.data == null) {
        return;
      }
      this.items = this.data.map(value => {
        const sumSummary = value.calories + value.protein + value.fat + value.carbs;
        const active = sumSummary > 0;
        return {
          ...value,
          active: active
        };
      });
    },
    fetchData ({page, filter, sort}) {
      const tablePage = pagination.createPage(
        this.items ? this.items : [],
        this.tableState,
        [''],
        this.tablePageSize,
        {page, filter, sort});
      this.tableState = tablePage.state;
      return tablePage.result;
    },
    timeFormatter (timestamp) {
      if (timestamp === null) return this.$t('health.summary.average');
      const date = new Date(timestamp * 1000);
      return date.toLocaleDateString('en-GB');
    },
    updateActive (row) {
      this.items = this.items.map(el => {
        if (el.timestamp === row.timestamp) {
          el.active = !el.active;
        }
        return {
          ...el
        };
      });
    },
    updateCharts () {
      const filteredData = this.items.filter(el => el.active);
      let filteredAvgCarbs = Math.round(filteredData.reduce((acc, cur) => acc + cur.carbs, 0) / filteredData.length);
      let filteredAvgKcals = Math.round(filteredData.reduce((acc, cur) => acc + cur.calories, 0) / filteredData.length);
      let filteredAvgFat = Math.round(filteredData.reduce((acc, cur) => acc + cur.fat, 0) / filteredData.length);
      let filteredAvgProtein = Math.round(filteredData.reduce((acc, cur) => acc + cur.protein, 0) / filteredData.length);

      this.$emit('selected', {
        filteredData: filteredData,
        avgCarbs: filteredAvgCarbs,
        avgKcals: filteredAvgKcals,
        avgFat: filteredAvgFat,
        avgProtein: filteredAvgProtein
      });
    },
    isActive: function (id) {
      const summary = this.data.find(item => item.timestamp === id);
      if (summary === undefined) return false;
      const sumSummary = summary.calories + summary.protein + summary.fat + summary.carbs;
      return sumSummary > 0;
    }
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/brand/health/components/summary/SummaryTable.vue